export default __webpack_public_path__ + "static/ep-1-9c1dfd4f595b5c7c6d1b79604d0b07b9.png";